import {Injectable, Injector}   from '@angular/core';
import {
    HttpEvent, HttpInterceptor, HttpHandler, HttpRequest
}                               from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError}             from 'rxjs/operators';
import {AuthService}            from '../services/auth.service';
import {environment}            from '@src/environments/environment';
import {BillingPolicyService}   from '@src/app/core/services/billing-policy.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor
{
    public constructor(
        private authService: AuthService,
        private injector: Injector,
    )
    {
    }

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
    {
        if (request.headers.get('X-Skip')) {
            return next.handle(request);
        }

        let authRequest = request;

        if (this.authService.accessToken && this.authService.tenant?.id) {
            authRequest = request.clone({
                setHeaders: {   // use setHeaders instead of HttpHeaders
                    'Authorization': `Bearer ${this.authService.accessToken}`,
                    'X-Tenant': `${this.authService.tenant.id}`,
                    'X-Client-Ident': `${environment.webEnum}`,
                    'X-Client-Capabilities': 'defect_task_workflow'
                }
            });
        }

        if (request.url.startsWith(`${environment.apiUrl}/`) && !request.headers.has('X-Test-Plan')) {
            const testPlan = this.injector.get(BillingPolicyService).testPlanHeader;
            if (testPlan) authRequest = authRequest.clone({setHeaders: {'X-Test-Plan': testPlan}});
        }

        return next.handle(authRequest).pipe(catchError(err => {
            if (err.status === 401) {
                this.authService.deauthenticateUser();
            }

            if (err.status === 403 && this.authService.tenant?.id && !request.url.includes('/payments/policy')) {
                void this.injector.get(BillingPolicyService).initialize(this.authService.tenant.id, true);
            }

            return throwError(() => err);
        }));
    }

    private tokenExpired(token: string)
    {
        const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
        return (Math.floor((new Date).getTime() / 1000)) >= expiry;
    }
}
